import { typographyMixin } from './typographyMixin';
export const predefinedMixins = {
    xxl: {
        regular: typographyMixin('xxl', 'regular'),
        contrastInvert: typographyMixin('xxl', 'contrastInvert'),
        overlay: typographyMixin('xxl', 'overlay'),
        overlayInvert: typographyMixin('xxl', 'overlayInvert'),
    },
    xl: {
        regular: typographyMixin('xl', 'regular'),
        contrastInvert: typographyMixin('xl', 'contrastInvert'),
        overlay: typographyMixin('xl', 'overlay'),
        overlayInvert: typographyMixin('xl', 'overlayInvert'),
    },
    lg: {
        regular: typographyMixin('lg', 'regular'),
        contrastInvert: typographyMixin('lg', 'contrastInvert'),
        overlay: typographyMixin('lg', 'overlay'),
        overlayInvert: typographyMixin('lg', 'overlayInvert'),
    },
    md: {
        highContrast: typographyMixin('md', 'highContrast'),
        regular: typographyMixin('md', 'regular'),
        lowContrast: typographyMixin('md', 'lowContrast'),
        url: typographyMixin('md', 'url'),
        success: typographyMixin('md', 'success'),
        warning: typographyMixin('md', 'warning'),
        error: typographyMixin('md', 'error'),
        contrastInvert: typographyMixin('md', 'contrastInvert'),
        overlay: typographyMixin('md', 'overlay'),
        overlayInvert: typographyMixin('md', 'overlayInvert'),
    },
    sm: {
        highContrast: typographyMixin('sm', 'highContrast'),
        regular: typographyMixin('sm', 'regular'),
        lowContrast: typographyMixin('sm', 'lowContrast'),
        url: typographyMixin('sm', 'url'),
        success: typographyMixin('sm', 'success'),
        warning: typographyMixin('sm', 'warning'),
        error: typographyMixin('sm', 'error'),
        contrastInvert: typographyMixin('sm', 'contrastInvert'),
        overlay: typographyMixin('sm', 'overlay'),
        overlayInvert: typographyMixin('sm', 'overlayInvert'),
    },
    xs: {
        highContrast: typographyMixin('xs', 'highContrast'),
        regular: typographyMixin('xs', 'regular'),
        lowContrast: typographyMixin('xs', 'lowContrast'),
        disabled: typographyMixin('xs', 'disabled'),
        url: typographyMixin('xs', 'url'),
        success: typographyMixin('xs', 'success'),
        warning: typographyMixin('xs', 'warning'),
        error: typographyMixin('xs', 'error'),
        contrastInvert: typographyMixin('xs', 'contrastInvert'),
        overlay: typographyMixin('xs', 'overlay'),
        overlayInvert: typographyMixin('xs', 'overlayInvert'),
    },
    xxs: {
        highContrast: typographyMixin('xxs', 'highContrast'),
        regular: typographyMixin('xxs', 'regular'),
        lowContrast: typographyMixin('xxs', 'lowContrast'),
        disabled: typographyMixin('xxs', 'disabled'),
        url: typographyMixin('xxs', 'url'),
        success: typographyMixin('xxs', 'success'),
        warning: typographyMixin('xxs', 'warning'),
        error: typographyMixin('xxs', 'error'),
        contrastInvert: typographyMixin('xxs', 'contrastInvert'),
        overlay: typographyMixin('xxs', 'overlay'),
        overlayInvert: typographyMixin('xxs', 'overlayInvert'),
    },
};
//# sourceMappingURL=predefinedMixins.js.map